import { TFunction } from "i18next";
import { Icons } from "./icons";
import { BrandType } from "../types";
import { ISelectListItem } from "../interfaces";
import { FuelType, TransmissionType, VehicleConditionType, VehicleOptionType } from "@bus/models";

export function getVehicleConditionList(t?: TFunction): ISelectListItem<string>[] {
    return [
        {
            id: "vehicleConditionNew",
            displayName: t ? t("question1page:vehicle-condition.options.new") : "",
            value: VehicleConditionType.NEW,
            icon: "",
        },
        {
            id: "vehicleConditionUsed",
            displayName: t ? t("question1page:vehicle-condition.options.used") : "",
            value: VehicleConditionType.USED,
            icon: "",
        },
    ];
}
export function getVehicleConditionDisplayName(value: VehicleConditionType, t?: TFunction) {
    const conditions = getVehicleConditionList(t);

    return conditions.filter((x) => x.value === value)[0]?.displayName ?? "";
}

export function getVehicleModelsList(brand?: BrandType): ISelectListItem<string>[] {
    const VehicleModels = {
        cupra: [
            {
                id: "CUPRAFormentor",
                displayName: "CUPRA Formentor",
                value: "CUPRA Formentor",
                icon: "",
            },
            {
                id: "CUPRALeon",
                displayName: "CUPRA Leon",
                value: "CUPRA Leon",
                icon: "",
            },
            {
                id: "CUPRALeonSportstourer",
                displayName: "CUPRA Leon Sportstourer",
                value: "CUPRA Leon Sportstourer",
                icon: "",
            },
            {
                id: "CUPRAAteca",
                displayName: "CUPRA Ateca",
                value: "CUPRA Ateca",
                icon: "",
            },
            {
                id: "CUPRABorn",
                displayName: "CUPRA Born",
                value: "CUPRA Born",
                icon: "",
            },
            {
                id: "CUPRATavascan",
                displayName: "CUPRA Tavascan",
                value: "CUPRA Tavascan",
                icon: "",
            },
            {
                id: "CUPRATerramar",
                displayName: "CUPRA Terramar",
                value: "CUPRA Terramar",
                icon: "",
            },
            {
                id: "CUPRARaval",
                displayName: "CUPRA Raval",
                value: "CUPRA Raval",
                icon: "",
            },
        ],
        seat: [
            {
                id: "SEATIbiza",
                displayName: "SEAT Ibiza",
                value: "SEAT Ibiza",
                icon: "",
            },
            {
                id: "SEATArona",
                displayName: "SEAT Arona",
                value: "SEAT Arona",
                icon: "",
            },
            {
                id: "SEATLeon",
                displayName: "SEAT Leon",
                value: "SEAT Leon",
                icon: "",
            },
            {
                id: "SEATLeonSportstourer",
                displayName: "SEAT Leon Sportstourer",
                value: "SEAT Leon Sportstourer",
                icon: "",
            },
            {
                id: "SEATAteca",
                displayName: "SEAT Ateca",
                value: "SEAT Ateca",
                icon: "",
            },
        ],
        audi: [
            {
                id: "AUDIA1",
                displayName: "A1",
                value: "A1",
                icon: "",
            },
            {
                id: "AUDIA3",
                displayName: "A3",
                value: "A3",
                icon: "",
            },
            {
                id: "AUDIA5",
                displayName: "A5",
                value: "A5",
                icon: "",
            },
            {
                id: "AUDIA6e-tron",
                displayName: "A6 e-tron",
                value: "A6 e-tron",
                icon: "",
            },
            {
                id: "AUDINuovaA7",
                displayName: "Nuova A7",
                value: "Nuova A7",
                icon: "",
            },
            {
                id: "AUDIA8",
                displayName: "A8",
                value: "A8",
                icon: "",
            },
            {
                id: "AUDIe-tronGT",
                displayName: "e-tron GT",
                value: "e-tron GT",
                icon: "",
            },
            {
                id: "AUDIQ2",
                displayName: "Q2",
                value: "Q2",
                icon: "",
            },
            {
                id: "AUDIQ3",
                displayName: "Q3",
                value: "Q3",
                icon: "",
            },
            {
                id: "AUDIQ4e-tron",
                displayName: "Q4 e-tron",
                value: "Q4 e-tron",
                icon: "",
            },
            {
                id: "AUDIQ5",
                displayName: "Q5",
                value: "Q5",
                icon: "",
            },
            {
                id: "AUDIQ6e-tron",
                displayName: "Q6 e-tron",
                value: "Q6 e-tron",
                icon: "",
            },
            {
                id: "AUDIQ7",
                displayName: "Q7",
                value: "Q7",
                icon: "",
            },
            {
                id: "AUDIQ8",
                displayName: "Q8",
                value: "Q8",
                icon: "",
            },
        ],
        vw: [
            {
                id: "VWPolo",
                displayName: "Polo",
                value: "Polo",
                icon: "",
            },
            {
                id: "VWGolf",
                displayName: "Golf",
                value: "Golf",
                icon: "",
            },
            {
                id: "VWGolfVariant",
                displayName: "Golf Variant",
                value: "Golf Variant",
                icon: "",
            },
            {
                id: "VWTaigo",
                displayName: "Taigo",
                value: "Taigo",
                icon: "",
            },
            {
                id: "VWT-Cross",
                displayName: "T-Cross",
                value: "T-Cross",
                icon: "",
            },
            {
                id: "VWT-Roc",
                displayName: "T-Roc",
                value: "T-Roc",
                icon: "",
            },
            {
                id: "VWTiguan",
                displayName: "Tiguan",
                value: "Tiguan",
                icon: "",
            },
            {
                id: "VWTayron",
                displayName: "Tayron",
                value: "Tayron",
                icon: "",
            },
            {
                id: "VWTouran",
                displayName: "Touran",
                value: "Touran",
                icon: "",
            },
            {
                id: "VWTouareg",
                displayName: "Touareg",
                value: "Touareg",
                icon: "",
            },
            {
                id: "VWPassat",
                displayName: "Passat",
                value: "Passat",
                icon: "",
            },
            {
                id: "VWT-RocCabrio",
                displayName: "T-Roc Cabrio",
                value: "T-Roc Cabrio",
                icon: "",
            },
            {
                id: "VWID.2",
                displayName: "ID.2",
                value: "ID.2",
                icon: "",
            },
            {
                id: "VWID.3",
                displayName: "ID.3",
                value: "ID.3",
                icon: "",
            },
            {
                id: "VWID.4",
                displayName: "ID.4",
                value: "ID.4",
                icon: "",
            },
            {
                id: "VWID.5",
                displayName: "ID.5",
                value: "ID.5",
                icon: "",
            },
            {
                id: "VWID.7",
                displayName: "ID.7",
                value: "ID.7",
                icon: "",
            },
            {
                id: "VWID.7Tourer",
                displayName: "ID.7 Tourer",
                value: "ID.7 Tourer",
                icon: "",
            },
            {
                id: "VWID.Cross",
                displayName: "ID.Cross",
                value: "ID.Cross",
                icon: "",
            },
        ],
        vwn: [
            {
                id: "VWNCaddy",
                displayName: "Caddy",
                value: "Caddy",
                icon: "",
            },
            {
                id: "VWNCaddyCargo",
                displayName: "Caddy Cargo",
                value: "Caddy Cargo",
                icon: "",
            },
            {
                id: "VWNTransporter",
                displayName: "Transporter",
                value: "Transporter",
                icon: "",
            },
            {
                id: "VWNCaravelle",
                displayName: "Caravelle",
                value: "Caravelle",
                icon: "",
            },
            {
                id: "VWNMultivan",
                displayName: "Multivan",
                value: "Multivan",
                icon: "",
            },
            {
                id: "VWNCalifornia",
                displayName: "California",
                value: "California",
                icon: "",
            },
            {
                id: "VWNGrandCalifornia",
                displayName: "Grand California",
                value: "Grand California",
                icon: "",
            },
            {
                id: "VWNCrafter",
                displayName: "Crafter",
                value: "Crafter",
                icon: "",
            },
            {
                id: "VWNAmarok",
                displayName: "Amarok",
                value: "Amarok",
                icon: "",
            },
            {
                id: "VWNID.Buzz",
                displayName: "ID. Buzz",
                value: "ID. Buzz",
                icon: "",
            },
            {
                id: "VWNID.BuzzCargo",
                displayName: "ID. Buzz Cargo",
                value: "ID. Buzz Cargo",
                icon: "",
            },
        ],
        skoda: [
            {
                id: "SKODAFabia",
                displayName: "Fabia",
                value: "Fabia",
                icon: "",
            },
            {
                id: "SKODAScala",
                displayName: "Scala",
                value: "Scala",
                icon: "",
            },
            {
                id: "SKODAKamiq",
                displayName: "Kamiq",
                value: "Kamiq",
                icon: "",
            },
            {
                id: "SKODAOctavia",
                displayName: "Octavia",
                value: "Octavia",
                icon: "",
            },
            {
                id: "SKODAOctaviaWagon",
                displayName: "Octavia Wagon",
                value: "Octavia Wagon",
                icon: "",
            },
            {
                id: "SKODAKaroq",
                displayName: "Karoq",
                value: "Karoq",
                icon: "",
            },
            {
                id: "SKODASuperbWagon",
                displayName: "Superb Wagon",
                value: "Superb Wagon",
                icon: "",
            },
            {
                id: "SKODAKodiaq",
                displayName: "Kodiaq",
                value: "Kodiaq",
                icon: "",
            },
            {
                id: "SKODAElroq",
                displayName: "Elroq",
                value: "Elroq",
                icon: "",
            },
            {
                id: "SKODAEnyaq",
                displayName: "Enyaq",
                value: "Enyaq",
                icon: "",
            },
            {
                id: "SKODAEpiq",
                displayName: "Epiq",
                value: "Epiq",
                icon: "",
            },
        ]
    };

    return VehicleModels[brand || (process.env.REACT_APP_WEBSITE_BRAND as BrandType)];
}

export function getVehicleFuelTypesList(t?: TFunction): ISelectListItem<string>[] {
    return [
        {
            id: "GASOLINE",
            displayName: t ? t("question1page:vehicle-fuel.options.petrol") : "",
            value: FuelType.V2_GASOLINE,
            icon: Icons.FuelPetrol,
        },
        {
            id: "DIESEL",
            displayName: t ? t("question1page:vehicle-fuel.options.diesel") : "",
            value: FuelType.V2_DIESEL,
            icon: Icons.FuelDiesel,
        },
        {
            id: "HYBRID_DIESEL",
            displayName: t ? t("question1page:vehicle-fuel.options.hybrid") : "",
            value: FuelType.V2_HYBRID,
            icon: Icons.FuelHybrid,
        },
        {
            id: "ELECTRICITY",
            displayName: t ? t("question1page:vehicle-fuel.options.electric") : "",
            value: FuelType.V2_ELECTRICITY,
            icon: Icons.FuelElectric,
        },
    ];
}
export function getVehicleFuelTypesDisplayName(value: FuelType, t?: TFunction) {
    const fuels = getVehicleFuelTypesList(t);

    return fuels.filter((x) => x.value === value)[0]?.displayName ?? "";
}

export function getVehicleOptionals(t?: Function, brand?: BrandType): ISelectListItem<string>[] {
    const VehicleModels = {
        cupra: [
            {
                id: VehicleOptionType.EQUIPMENT_SPEED_CONTROL,
                displayName: t ? t("question3page:equipment.options.cruise-control.title") : "",
                value: VehicleOptionType.EQUIPMENT_SPEED_CONTROL,
                icon: "",
            },
            {
                id: VehicleOptionType.EQUIPMENT_DRIVER_ASSISTANCE,
                displayName: t ? t("question3page:equipment.options.driver-assistance.title") : "",
                value: VehicleOptionType.EQUIPMENT_DRIVER_ASSISTANCE,
                icon: "",
            },
            {
                id: VehicleOptionType.PACKAGE_KEYLESS,
                displayName: t ? t("question3page:equipment.options.keyless-pack.title") : "",
                value: VehicleOptionType.PACKAGE_KEYLESS,
                icon: "",
            },
            {
                id: VehicleOptionType.PACKAGE_NAVIGATOR,
                displayName: t ? t("question3page:equipment.options.navigation-system.title") : "",
                value: VehicleOptionType.PACKAGE_NAVIGATOR,
                icon: "",
            },
            {
                id: VehicleOptionType.PACKAGE_SUN_ROOF,
                displayName: t ? t("question3page:equipment.options.panoramic-roof.title") : "",
                value: VehicleOptionType.PACKAGE_SUN_ROOF,
                icon: "",
            },
            {
                id: VehicleOptionType.EQUIPMENT_CAR_ALARM,
                displayName: t ? t("question3page:equipment.options.volumetric-anti-theft.title") : "",
                value: VehicleOptionType.EQUIPMENT_CAR_ALARM,
                icon: "",
            },
            {
                id: VehicleOptionType.ACCESSORY_PARKING,
                displayName: t ? t("question3page:equipment.options.parking-sensors.title") : "",
                value: VehicleOptionType.ACCESSORY_PARKING,
                icon: "",
            },
            {
                id: VehicleOptionType.ACCESSORY_INFOTAIMENT,
                displayName: t ? t("question3page:equipment.options.audio-infotaiment.title") : "",
                value: VehicleOptionType.ACCESSORY_INFOTAIMENT,
                icon: "",
            },
            {
                id: VehicleOptionType.ACCESSORY_INTERIOR,
                displayName: t ? t("question3page:equipment.options.heated-seats.title") : "",
                value: VehicleOptionType.ACCESSORY_INTERIOR,
                icon: "",
            },
            {
                id: VehicleOptionType.ACCESSORY_LEATHER,
                displayName: t ? t("question3page:equipment.options.leather-seats.title") : "",
                value: VehicleOptionType.ACCESSORY_LEATHER,
                icon: "",
            },
            {
                id: VehicleOptionType.PACKAGE_BLUETOOTH,
                displayName: t ? t("question3page:equipment.options.bluetooth.title") : "",
                value: VehicleOptionType.PACKAGE_BLUETOOTH,
                icon: "",
            },
            {
                id: VehicleOptionType.PACKAGE_CAMERA,
                displayName: t ? t("question3page:equipment.options.rear-camera.title") : "",
                value: VehicleOptionType.PACKAGE_CAMERA,
                icon: "",
            },
            {
                id: VehicleOptionType.WHEELS_RIM_ALLOY,
                displayName: t ? t("question3page:equipment.options.alloy-wheels.title") : "",
                value: VehicleOptionType.WHEELS_RIM_ALLOY,
                icon: "",
            },
            {
                id: VehicleOptionType.SYSTEM_EQUIPMENT_FULL_LED_HEADLIGHTS,
                displayName: t ? t("question3page:equipment.options.full-led-headlights.title") : "",
                value: VehicleOptionType.SYSTEM_EQUIPMENT_FULL_LED_HEADLIGHTS,
                icon: "",
            },
            {
                id: VehicleOptionType.ACCESSORY_REAR_VIEW_MIRRORS,
                displayName: t ? t("question3page:equipment.options.mirrors.title") : "",
                value: VehicleOptionType.ACCESSORY_REAR_VIEW_MIRRORS,
                icon: "",
            },
            {
                id: VehicleOptionType.EQUIPMENT_AIRBAGS,
                displayName: t ? t("question3page:equipment.options.Airbags.title") : "",
                value: VehicleOptionType.EQUIPMENT_AIRBAGS,
                icon: "",
            },
            {
                id: VehicleOptionType.VEHICLE_COMPACT_SPARE_TYRE,
                displayName: t ? t("question3page:equipment.options.spare-wheel.title") : "",
                value: VehicleOptionType.VEHICLE_COMPACT_SPARE_TYRE,
                icon: "",
            },
            {
                id: VehicleOptionType.EQUIPMENT_AIR_CONDITIONING,
                displayName: t ? t("question3page:equipment.options.automatic-air-conditioning-and-heating.title") : "",
                value: VehicleOptionType.EQUIPMENT_AIR_CONDITIONING,
                icon: "",
            },
            {
                id: VehicleOptionType.EQUIPMENT_MULTIFUNCTION_STEERING_WHEEL,
                displayName: t ? t("question3page:equipment.options.multifunctional-steering-wheel.title") : "",
                value: VehicleOptionType.EQUIPMENT_MULTIFUNCTION_STEERING_WHEEL,
                icon: "",
            },
            {
                id: VehicleOptionType.PACKAGE_WALLBOX,
                displayName: t ? t("question3page:equipment.options.power-wallbox.title") : "",
                value: VehicleOptionType.PACKAGE_WALLBOX,
                icon: "",
            },
        ],
        seat: [
            {
                id: VehicleOptionType.EQUIPMENT_SPEED_CONTROL,
                displayName: t ? t("question3page:equipment.options.cruise-control.title") : "",
                value: VehicleOptionType.EQUIPMENT_SPEED_CONTROL,
                icon: "",
            },
            {
                id: VehicleOptionType.EQUIPMENT_DRIVER_ASSISTANCE,
                displayName: t ? t("question3page:equipment.options.driver-assistance.title") : "",
                value: VehicleOptionType.EQUIPMENT_DRIVER_ASSISTANCE,
                icon: "",
            },
            {
                id: VehicleOptionType.PACKAGE_KEYLESS,
                displayName: t ? t("question3page:equipment.options.keyless-pack.title") : "",
                value: VehicleOptionType.PACKAGE_KEYLESS,
                icon: "",
            },
            {
                id: VehicleOptionType.PACKAGE_NAVIGATOR,
                displayName: t ? t("question3page:equipment.options.navigation-system.title") : "",
                value: VehicleOptionType.PACKAGE_NAVIGATOR,
                icon: "",
            },
            {
                id: VehicleOptionType.PACKAGE_SUN_ROOF,
                displayName: t ? t("question3page:equipment.options.panoramic-roof.title") : "",
                value: VehicleOptionType.PACKAGE_SUN_ROOF,
                icon: "",
            },
            {
                id: VehicleOptionType.EQUIPMENT_CAR_ALARM,
                displayName: t ? t("question3page:equipment.options.volumetric-anti-theft.title") : "",
                value: VehicleOptionType.EQUIPMENT_CAR_ALARM,
                icon: "",
            },
            {
                id: VehicleOptionType.ACCESSORY_PARKING,
                displayName: t ? t("question3page:equipment.options.parking-sensors.title") : "",
                value: VehicleOptionType.ACCESSORY_PARKING,
                icon: "",
            },
            {
                id: VehicleOptionType.ACCESSORY_INFOTAIMENT,
                displayName: t ? t("question3page:equipment.options.audio-infotaiment.title") : "",
                value: VehicleOptionType.ACCESSORY_INFOTAIMENT,
                icon: "",
            },
            {
                id: VehicleOptionType.ACCESSORY_INTERIOR,
                displayName: t ? t("question3page:equipment.options.heated-seats.title") : "",
                value: VehicleOptionType.ACCESSORY_INTERIOR,
                icon: "",
            },
            {
                id: VehicleOptionType.ACCESSORY_LEATHER,
                displayName: t ? t("question3page:equipment.options.leather-seats.title") : "",
                value: VehicleOptionType.ACCESSORY_LEATHER,
                icon: "",
            },
            {
                id: VehicleOptionType.PACKAGE_BLUETOOTH,
                displayName: t ? t("question3page:equipment.options.bluetooth.title") : "",
                value: VehicleOptionType.PACKAGE_BLUETOOTH,
                icon: "",
            },
            {
                id: VehicleOptionType.PACKAGE_CAMERA,
                displayName: t ? t("question3page:equipment.options.rear-camera.title") : "",
                value: VehicleOptionType.PACKAGE_CAMERA,
                icon: "",
            },
            {
                id: VehicleOptionType.WHEELS_RIM_ALLOY,
                displayName: t ? t("question3page:equipment.options.alloy-wheels.title") : "",
                value: VehicleOptionType.WHEELS_RIM_ALLOY,
                icon: "",
            },
            {
                id: VehicleOptionType.SYSTEM_EQUIPMENT_FULL_LED_HEADLIGHTS,
                displayName: t ? t("question3page:equipment.options.full-led-headlights.title") : "",
                value: VehicleOptionType.SYSTEM_EQUIPMENT_FULL_LED_HEADLIGHTS,
                icon: "",
            },
            {
                id: VehicleOptionType.ACCESSORY_REAR_VIEW_MIRRORS,
                displayName: t ? t("question3page:equipment.options.mirrors.title") : "",
                value: VehicleOptionType.ACCESSORY_REAR_VIEW_MIRRORS,
                icon: "",
            },
            {
                id: VehicleOptionType.EQUIPMENT_AIRBAGS,
                displayName: t ? t("question3page:equipment.options.Airbags.title") : "",
                value: VehicleOptionType.EQUIPMENT_AIRBAGS,
                icon: "",
            },
            {
                id: VehicleOptionType.VEHICLE_COMPACT_SPARE_TYRE,
                displayName: t ? t("question3page:equipment.options.spare-wheel.title") : "",
                value: VehicleOptionType.VEHICLE_COMPACT_SPARE_TYRE,
                icon: "",
            },
            {
                id: VehicleOptionType.EQUIPMENT_AIR_CONDITIONING,
                displayName: t ? t("question3page:equipment.options.automatic-air-conditioning-and-heating.title") : "",
                value: VehicleOptionType.EQUIPMENT_AIR_CONDITIONING,
                icon: "",
            },
            {
                id: VehicleOptionType.EQUIPMENT_MULTIFUNCTION_STEERING_WHEEL,
                displayName: t ? t("question3page:equipment.options.multifunctional-steering-wheel.title") : "",
                value: VehicleOptionType.EQUIPMENT_MULTIFUNCTION_STEERING_WHEEL,
                icon: "",
            },
        ],
        audi: [
            {
                id: VehicleOptionType.EQUIPMENT_SPEED_CONTROL,
                displayName: t ? t("question3page:equipment.options.cruise-control.title") : "",
                value: VehicleOptionType.EQUIPMENT_SPEED_CONTROL,
                icon: "",
            },
            {
                id: VehicleOptionType.EQUIPMENT_DRIVER_ASSISTANCE,
                displayName: t ? t("question3page:equipment.options.driver-assistance.title") : "",
                value: VehicleOptionType.EQUIPMENT_DRIVER_ASSISTANCE,
                icon: "",
            },
            {
                id: VehicleOptionType.PACKAGE_KEYLESS,
                displayName: t ? t("question3page:equipment.options.keyless-pack.title") : "",
                value: VehicleOptionType.PACKAGE_KEYLESS,
                icon: "",
            },
            {
                id: VehicleOptionType.PACKAGE_NAVIGATOR,
                displayName: t ? t("question3page:equipment.options.navigation-system.title") : "",
                value: VehicleOptionType.PACKAGE_NAVIGATOR,
                icon: "",
            },
            {
                id: VehicleOptionType.PACKAGE_SUN_ROOF,
                displayName: t ? t("question3page:equipment.options.panoramic-roof.title") : "",
                value: VehicleOptionType.PACKAGE_SUN_ROOF,
                icon: "",
            },
            {
                id: VehicleOptionType.EQUIPMENT_CAR_ALARM,
                displayName: t ? t("question3page:equipment.options.volumetric-anti-theft.title") : "",
                value: VehicleOptionType.EQUIPMENT_CAR_ALARM,
                icon: "",
            },
            {
                id: VehicleOptionType.ACCESSORY_PARKING,
                displayName: t ? t("question3page:equipment.options.parking-sensors.title") : "",
                value: VehicleOptionType.ACCESSORY_PARKING,
                icon: "",
            },
            {
                id: VehicleOptionType.ACCESSORY_INFOTAIMENT,
                displayName: t ? t("question3page:equipment.options.audio-infotaiment.title") : "",
                value: VehicleOptionType.ACCESSORY_INFOTAIMENT,
                icon: "",
            },
            {
                id: VehicleOptionType.ACCESSORY_INTERIOR,
                displayName: t ? t("question3page:equipment.options.heated-seats.title") : "",
                value: VehicleOptionType.ACCESSORY_INTERIOR,
                icon: "",
            },
            {
                id: VehicleOptionType.ACCESSORY_LEATHER,
                displayName: t ? t("question3page:equipment.options.leather-seats.title") : "",
                value: VehicleOptionType.ACCESSORY_LEATHER,
                icon: "",
            },
            {
                id: VehicleOptionType.PACKAGE_BLUETOOTH,
                displayName: t ? t("question3page:equipment.options.bluetooth.title") : "",
                value: VehicleOptionType.PACKAGE_BLUETOOTH,
                icon: "",
            },
            {
                id: VehicleOptionType.PACKAGE_CAMERA,
                displayName: t ? t("question3page:equipment.options.rear-camera.title") : "",
                value: VehicleOptionType.PACKAGE_CAMERA,
                icon: "",
            },
            {
                id: VehicleOptionType.WHEELS_RIM_ALLOY,
                displayName: t ? t("question3page:equipment.options.alloy-wheels.title") : "",
                value: VehicleOptionType.WHEELS_RIM_ALLOY,
                icon: "",
            },
            {
                id: VehicleOptionType.SYSTEM_EQUIPMENT_FULL_LED_HEADLIGHTS,
                displayName: t ? t("question3page:equipment.options.full-led-headlights.title") : "",
                value: VehicleOptionType.SYSTEM_EQUIPMENT_FULL_LED_HEADLIGHTS,
                icon: "",
            },
            {
                id: VehicleOptionType.ACCESSORY_REAR_VIEW_MIRRORS,
                displayName: t ? t("question3page:equipment.options.mirrors.title") : "",
                value: VehicleOptionType.ACCESSORY_REAR_VIEW_MIRRORS,
                icon: "",
            },
            {
                id: VehicleOptionType.EQUIPMENT_AIRBAGS,
                displayName: t ? t("question3page:equipment.options.Airbags.title") : "",
                value: VehicleOptionType.EQUIPMENT_AIRBAGS,
                icon: "",
            },
            {
                id: VehicleOptionType.VEHICLE_COMPACT_SPARE_TYRE,
                displayName: t ? t("question3page:equipment.options.spare-wheel.title") : "",
                value: VehicleOptionType.VEHICLE_COMPACT_SPARE_TYRE,
                icon: "",
            },
            {
                id: VehicleOptionType.EQUIPMENT_AIR_CONDITIONING,
                displayName: t ? t("question3page:equipment.options.automatic-air-conditioning-and-heating.title") : "",
                value: VehicleOptionType.EQUIPMENT_AIR_CONDITIONING,
                icon: "",
            },
            {
                id: VehicleOptionType.EQUIPMENT_MULTIFUNCTION_STEERING_WHEEL,
                displayName: t ? t("question3page:equipment.options.multifunctional-steering-wheel.title") : "",
                value: VehicleOptionType.EQUIPMENT_MULTIFUNCTION_STEERING_WHEEL,
                icon: "",
            },
            {
                id: VehicleOptionType.PACKAGE_WALLBOX,
                displayName: t ? t("question3page:equipment.options.power-wallbox.title") : "",
                value: VehicleOptionType.PACKAGE_WALLBOX,
                icon: "",
            },
        ],
        vw: [
            {
                id: VehicleOptionType.EQUIPMENT_SPEED_CONTROL,
                displayName: t ? t("question3page:equipment.options.cruise-control.title") : "",
                value: VehicleOptionType.EQUIPMENT_SPEED_CONTROL,
                icon: "",
            },
            {
                id: VehicleOptionType.EQUIPMENT_DRIVER_ASSISTANCE,
                displayName: t ? t("question3page:equipment.options.driver-assistance.title") : "",
                value: VehicleOptionType.EQUIPMENT_DRIVER_ASSISTANCE,
                icon: "",
            },
            {
                id: VehicleOptionType.PACKAGE_KEYLESS,
                displayName: t ? t("question3page:equipment.options.keyless-pack.title") : "",
                value: VehicleOptionType.PACKAGE_KEYLESS,
                icon: "",
            },
            {
                id: VehicleOptionType.PACKAGE_NAVIGATOR,
                displayName: t ? t("question3page:equipment.options.navigation-system.title") : "",
                value: VehicleOptionType.PACKAGE_NAVIGATOR,
                icon: "",
            },
            {
                id: VehicleOptionType.PACKAGE_SUN_ROOF,
                displayName: t ? t("question3page:equipment.options.panoramic-roof.title") : "",
                value: VehicleOptionType.PACKAGE_SUN_ROOF,
                icon: "",
            },
            {
                id: VehicleOptionType.EQUIPMENT_CAR_ALARM,
                displayName: t ? t("question3page:equipment.options.volumetric-anti-theft.title") : "",
                value: VehicleOptionType.EQUIPMENT_CAR_ALARM,
                icon: "",
            },
            {
                id: VehicleOptionType.ACCESSORY_PARKING,
                displayName: t ? t("question3page:equipment.options.parking-sensors.title") : "",
                value: VehicleOptionType.ACCESSORY_PARKING,
                icon: "",
            },
            {
                id: VehicleOptionType.ACCESSORY_INFOTAIMENT,
                displayName: t ? t("question3page:equipment.options.audio-infotaiment.title") : "",
                value: VehicleOptionType.ACCESSORY_INFOTAIMENT,
                icon: "",
            },
            {
                id: VehicleOptionType.ACCESSORY_INTERIOR,
                displayName: t ? t("question3page:equipment.options.heated-seats.title") : "",
                value: VehicleOptionType.ACCESSORY_INTERIOR,
                icon: "",
            },
            {
                id: VehicleOptionType.ACCESSORY_LEATHER,
                displayName: t ? t("question3page:equipment.options.leather-seats.title") : "",
                value: VehicleOptionType.ACCESSORY_LEATHER,
                icon: "",
            },
            {
                id: VehicleOptionType.PACKAGE_BLUETOOTH,
                displayName: t ? t("question3page:equipment.options.bluetooth.title") : "",
                value: VehicleOptionType.PACKAGE_BLUETOOTH,
                icon: "",
            },
            {
                id: VehicleOptionType.PACKAGE_CAMERA,
                displayName: t ? t("question3page:equipment.options.rear-camera.title") : "",
                value: VehicleOptionType.PACKAGE_CAMERA,
                icon: "",
            },
            {
                id: VehicleOptionType.WHEELS_RIM_ALLOY,
                displayName: t ? t("question3page:equipment.options.alloy-wheels.title") : "",
                value: VehicleOptionType.WHEELS_RIM_ALLOY,
                icon: "",
            },
            {
                id: VehicleOptionType.SYSTEM_EQUIPMENT_FULL_LED_HEADLIGHTS,
                displayName: t ? t("question3page:equipment.options.full-led-headlights.title") : "",
                value: VehicleOptionType.SYSTEM_EQUIPMENT_FULL_LED_HEADLIGHTS,
                icon: "",
            },
            {
                id: VehicleOptionType.ACCESSORY_REAR_VIEW_MIRRORS,
                displayName: t ? t("question3page:equipment.options.mirrors.title") : "",
                value: VehicleOptionType.ACCESSORY_REAR_VIEW_MIRRORS,
                icon: "",
            },
            {
                id: VehicleOptionType.EQUIPMENT_AIRBAGS,
                displayName: t ? t("question3page:equipment.options.Airbags.title") : "",
                value: VehicleOptionType.EQUIPMENT_AIRBAGS,
                icon: "",
            },
            {
                id: VehicleOptionType.VEHICLE_COMPACT_SPARE_TYRE,
                displayName: t ? t("question3page:equipment.options.spare-wheel.title") : "",
                value: VehicleOptionType.VEHICLE_COMPACT_SPARE_TYRE,
                icon: "",
            },
            {
                id: VehicleOptionType.EQUIPMENT_AIR_CONDITIONING,
                displayName: t ? t("question3page:equipment.options.automatic-air-conditioning-and-heating.title") : "",
                value: VehicleOptionType.EQUIPMENT_AIR_CONDITIONING,
                icon: "",
            },
            {
                id: VehicleOptionType.EQUIPMENT_MULTIFUNCTION_STEERING_WHEEL,
                displayName: t ? t("question3page:equipment.options.multifunctional-steering-wheel.title") : "",
                value: VehicleOptionType.EQUIPMENT_MULTIFUNCTION_STEERING_WHEEL,
                icon: "",
            },
        ],
        vwn: [
            {
                id: VehicleOptionType.EQUIPMENT_DRIVER_ASSISTANCE,
                displayName: t ? t("question3page:equipment.options.driver-assistance.title") : "",
                value: VehicleOptionType.EQUIPMENT_DRIVER_ASSISTANCE,
                icon: "",
            },
            {
                id: VehicleOptionType.PACKAGE_KEYLESS,
                displayName: t ? t("question3page:equipment.options.keyless-pack.alt") : "",
                value: VehicleOptionType.PACKAGE_KEYLESS,
                icon: "",
            },
            {
                id: VehicleOptionType.PACKAGE_NAVIGATOR,
                displayName: t ? t("question3page:equipment.options.navigation-system.title") : "",
                value: VehicleOptionType.PACKAGE_NAVIGATOR,
                icon: "",
            },
            {
                id: VehicleOptionType.PACKAGE_SUN_ROOF,
                displayName: t ? t("question3page:equipment.options.panoramic-roof.title") : "",
                value: VehicleOptionType.PACKAGE_SUN_ROOF,
                icon: "",
            },
            {
                id: VehicleOptionType.EQUIPMENT_CAR_ALARM,
                displayName: t ? t("question3page:equipment.options.volumetric-anti-theft.title") : "",
                value: VehicleOptionType.EQUIPMENT_CAR_ALARM,
                icon: "",
            },
            {
                id: VehicleOptionType.ACCESSORY_PARKING,
                displayName: t ? t("question3page:equipment.options.parking-sensors.title") : "",
                value: VehicleOptionType.ACCESSORY_PARKING,
                icon: "",
            },
            {
                id: VehicleOptionType.ACCESSORY_INFOTAIMENT,
                displayName: t ? t("question3page:equipment.options.audio-infotaiment.title") : "",
                value: VehicleOptionType.ACCESSORY_INFOTAIMENT,
                icon: "",
            },
            {
                id: VehicleOptionType.ACCESSORY_INTERIOR,
                displayName: t ? t("question3page:equipment.options.heated-seats.title") : "",
                value: VehicleOptionType.ACCESSORY_INTERIOR,
                icon: "",
            },
            {
                id: VehicleOptionType.PACKAGE_BLUETOOTH,
                displayName: t ? t("question3page:equipment.options.bluetooth.alt") : "",
                value: VehicleOptionType.PACKAGE_BLUETOOTH,
                icon: "",
            },
            {
                id: VehicleOptionType.PACKAGE_CAMERA,
                displayName: t ? t("question3page:equipment.options.rear-camera.title") : "",
                value: VehicleOptionType.PACKAGE_CAMERA,
                icon: "",
            },
            {
                id: VehicleOptionType.WHEELS_RIM_ALLOY,
                displayName: t ? t("question3page:equipment.options.alloy-wheels.title") : "",
                value: VehicleOptionType.WHEELS_RIM_ALLOY,
                icon: "",
            },
            {
                id: VehicleOptionType.SYSTEM_EQUIPMENT_FULL_LED_HEADLIGHTS,
                displayName: t ? t("question3page:equipment.options.full-led-headlights.title") : "",
                value: VehicleOptionType.SYSTEM_EQUIPMENT_FULL_LED_HEADLIGHTS,
                icon: "",
            },
            {
                id: VehicleOptionType.VEHICLE_COMPACT_SPARE_TYRE,
                displayName: t ? t("question3page:equipment.options.spare-wheel.alt") : "",
                value: VehicleOptionType.VEHICLE_COMPACT_SPARE_TYRE,
                icon: "",
            },
            {
                id: VehicleOptionType.EQUIPMENT_AIR_CONDITIONING,
                displayName: t ? t("question3page:equipment.options.automatic-air-conditioning-and-heating.title") : "",
                value: VehicleOptionType.EQUIPMENT_AIR_CONDITIONING,
                icon: "",
            },
            {
                id: VehicleOptionType.EQUIPMENT_MULTIFUNCTION_STEERING_WHEEL,
                displayName: t ? t("question3page:equipment.options.multifunctional-steering-wheel.title") : "",
                value: VehicleOptionType.EQUIPMENT_MULTIFUNCTION_STEERING_WHEEL,
                icon: "",
            },
        ],
        skoda: [
            {
                id: VehicleOptionType.EQUIPMENT_SPEED_CONTROL,
                displayName: t ? t("question3page:equipment.options.cruise-control.title") : "",
                value: VehicleOptionType.EQUIPMENT_SPEED_CONTROL,
                icon: "",
            },
            {
                id: VehicleOptionType.EQUIPMENT_DRIVER_ASSISTANCE,
                displayName: t ? t("question3page:equipment.options.driver-assistance.title") : "",
                value: VehicleOptionType.EQUIPMENT_DRIVER_ASSISTANCE,
                icon: "",
            },
            {
                id: VehicleOptionType.PACKAGE_KEYLESS,
                displayName: t ? t("question3page:equipment.options.keyless-pack.title") : "",
                value: VehicleOptionType.PACKAGE_KEYLESS,
                icon: "",
            },
            {
                id: VehicleOptionType.PACKAGE_NAVIGATOR,
                displayName: t ? t("question3page:equipment.options.navigation-system.title") : "",
                value: VehicleOptionType.PACKAGE_NAVIGATOR,
                icon: "",
            },
            {
                id: VehicleOptionType.PACKAGE_SUN_ROOF,
                displayName: t ? t("question3page:equipment.options.panoramic-roof.title") : "",
                value: VehicleOptionType.PACKAGE_SUN_ROOF,
                icon: "",
            },
            {
                id: VehicleOptionType.EQUIPMENT_CAR_ALARM,
                displayName: t ? t("question3page:equipment.options.volumetric-anti-theft.title") : "",
                value: VehicleOptionType.EQUIPMENT_CAR_ALARM,
                icon: "",
            },
            {
                id: VehicleOptionType.ACCESSORY_PARKING,
                displayName: t ? t("question3page:equipment.options.parking-sensors.title") : "",
                value: VehicleOptionType.ACCESSORY_PARKING,
                icon: "",
            },
            {
                id: VehicleOptionType.ACCESSORY_INFOTAIMENT,
                displayName: t ? t("question3page:equipment.options.audio-infotaiment.title") : "",
                value: VehicleOptionType.ACCESSORY_INFOTAIMENT,
                icon: "",
            },
            {
                id: VehicleOptionType.ACCESSORY_INTERIOR,
                displayName: t ? t("question3page:equipment.options.heated-seats.title") : "",
                value: VehicleOptionType.ACCESSORY_INTERIOR,
                icon: "",
            },
            {
                id: VehicleOptionType.ACCESSORY_LEATHER,
                displayName: t ? t("question3page:equipment.options.leather-seats.title") : "",
                value: VehicleOptionType.ACCESSORY_LEATHER,
                icon: "",
            },
            {
                id: VehicleOptionType.PACKAGE_BLUETOOTH,
                displayName: t ? t("question3page:equipment.options.bluetooth.title") : "",
                value: VehicleOptionType.PACKAGE_BLUETOOTH,
                icon: "",
            },
            {
                id: VehicleOptionType.PACKAGE_CAMERA,
                displayName: t ? t("question3page:equipment.options.rear-camera.title") : "",
                value: VehicleOptionType.PACKAGE_CAMERA,
                icon: "",
            },
            {
                id: VehicleOptionType.WHEELS_RIM_ALLOY,
                displayName: t ? t("question3page:equipment.options.alloy-wheels.title") : "",
                value: VehicleOptionType.WHEELS_RIM_ALLOY,
                icon: "",
            },
            {
                id: VehicleOptionType.SYSTEM_EQUIPMENT_FULL_LED_HEADLIGHTS,
                displayName: t ? t("question3page:equipment.options.full-led-headlights.title") : "",
                value: VehicleOptionType.SYSTEM_EQUIPMENT_FULL_LED_HEADLIGHTS,
                icon: "",
            },
            {
                id: VehicleOptionType.ACCESSORY_REAR_VIEW_MIRRORS,
                displayName: t ? t("question3page:equipment.options.mirrors.title") : "",
                value: VehicleOptionType.ACCESSORY_REAR_VIEW_MIRRORS,
                icon: "",
            },
            {
                id: VehicleOptionType.EQUIPMENT_AIRBAGS,
                displayName: t ? t("question3page:equipment.options.Airbags.title") : "",
                value: VehicleOptionType.EQUIPMENT_AIRBAGS,
                icon: "",
            },
            {
                id: VehicleOptionType.VEHICLE_COMPACT_SPARE_TYRE,
                displayName: t ? t("question3page:equipment.options.spare-wheel.title") : "",
                value: VehicleOptionType.VEHICLE_COMPACT_SPARE_TYRE,
                icon: "",
            },
            {
                id: VehicleOptionType.EQUIPMENT_AIR_CONDITIONING,
                displayName: t ? t("question3page:equipment.options.automatic-air-conditioning-and-heating.title") : "",
                value: VehicleOptionType.EQUIPMENT_AIR_CONDITIONING,
                icon: "",
            },
            {
                id: VehicleOptionType.EQUIPMENT_MULTIFUNCTION_STEERING_WHEEL,
                displayName: t ? t("question3page:equipment.options.multifunctional-steering-wheel.title") : "",
                value: VehicleOptionType.EQUIPMENT_MULTIFUNCTION_STEERING_WHEEL,
                icon: "",
            },
        ],
    };
    return VehicleModels[brand || (process.env.REACT_APP_WEBSITE_BRAND as BrandType)];
}
export function getVehicleOptionalsDisplayName(value: VehicleOptionType, t?: TFunction) {
    const optionals = getVehicleOptionals(t);

    return optionals.filter((x) => x.value === value)[0]?.displayName ?? "";
}

export function getVehicleTransmissionTypesList(t?: TFunction): ISelectListItem<string>[] {
    return [
        {
            id: TransmissionType.MANUAL,
            displayName: t ? t("question3page:transmission-type.options.manual") : "",
            value: TransmissionType.MANUAL,
            icon: Icons.TransmissionManual,
        },
        {
            id: TransmissionType.AUTOMATIC,
            displayName: t ? t("question3page:transmission-type.options.automatic") : "",
            value: TransmissionType.AUTOMATIC,
            icon: Icons.TransmissionAutomatic,
        },
    ];
}
export function getVehicleTransmissionTypesDisplayName(value: TransmissionType, t?: TFunction) {
    const transmission = getVehicleTransmissionTypesList(t);

    return transmission.filter((x) => x.value === value)[0]?.displayName ?? "";
}